import './styles/uiLocker.scss';
import { useStore } from '@/store/useStore';

/**
 * Full-surface lock shown while the net-position feature has locked the UI
 * after repeated failures. Reads the global `lockUI` flag from the store.
 */
export const UILocker = () => {
  const lockUI = useStore((s) => s.lockUI);

  if (!lockUI) {
    return null;
  }

  return (
    <div className="ui-locker" data-testid="ui-locker">
      <div className="ui-lock-spinner" />
    </div>
  );
};

export default UILocker;
